<template>
  <div class="wrapper list-item">
    <div v-if="item">
      <div class="campaign-holder">
        <div class="campaign-container">
          <p class="affiliate_id campaign-content">
            <span>{{ item.country }} - {{ item.vertical }}</span>
          </p>
          <p v-for="campaign in item.campaigns" class="campaign-list-item campaign-content" :key="campaign.campaign_id">
            <span><b>{{ campaign.campaign_id }}</b> {{ campaign.name }}</span>
          </p>
        </div>
        <div class="vertical-container" v-if="$store.state.user.affiliate_id == '0'">
          <p class="vertical-content">{{ item.affiliate_id }}</p>
        </div>
      </div>
      <el-tag v-for="strategy in item.strategies" :key="strategy.id" type="primary">{{ strategyMap[strategy.strategy] || strategy.strategy }}</el-tag>
    </div>
    <div v-else>
      <div class="campaign-holder">
        <div class="campaign-container no-results">
          <p><span>Sorry!</span></p>
          <p><span>No Rotators Available</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const strategyMap = { 
  'ml'        : 'Machine Learning',
  'threshold' : 'Blended EPC',
  'maximize'  : 'Maximum EPC',
  'minimize'  : 'Ordered',
  'weighted'  : 'Weighted'
}

export default {
  name: 'rotator-list-item',
  props: ['item'],
  data() {
    return {
      strategyMap
    }
  }
}
</script>
<style src="../static/css/list-item.css"></style>
<style lang="scss" scoped>
.campaign-holder
{ /*Campaign Holder*/
  margin-bottom: 15px;

  .campaign-content{
    padding: 0;

    b {
      width: 38px;
      display: inline-block;
    }
  }
  .affiliate_id{
    font-size: 15px;
    color: #ececec;
  }
  .campaign-container,
  .vertical-container{
    display: inline-block;
    vertical-align: top;
  }
  .campaign-container{
    width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .vertical-container{
    position: absolute;
    top: 0;
    right: 20px;
    text-transform: uppercase;
    overflow: hidden;
    vertical-align: center;

    .vertical-content{
      vertical-align: middle;
      font-size: 14px;
      line-height: 40px;
      height: 45px;
      text-align: center;
    }
  }
}
.el-tag {
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// rotator-list-item.vue?9d96069a